import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";

export const SchedulesSkeleton = () => {
  return (
    <>
      <Box style={{ display: "flex", justifyContent: "center" }}>
        <Skeleton variant="text" className="text-center" width={350} />
      </Box>
      <Box className="agenda-wrap bg-white p-3 rounded-4">
        <Box className="row flex-nowrap text-12">
          <Box className="col-4 small">
            <Skeleton variant="text" className="fw-bold d-block text-primary" />
            <Skeleton variant="text" className="d-block mb-3" />
          </Box>
          <Box className="col-4 small">
            <Skeleton variant="text" className="fw-bold d-block text-primary" />
            <Skeleton variant="text" className="d-block mb-3" />
          </Box>
          <Box className="col-4 small">
            <Skeleton variant="text" className="fw-bold d-block text-primary" />
            <Skeleton variant="text" className="d-block mb-3" />
          </Box>
        </Box>
        <Box className="overflow-agenda mb-3">
          <Box className="row flex-nowrap">
            <Box className="col-4">
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
            </Box>
            <Box className="col-4">
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
            </Box>
            <Box className="col-4">
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
              <Skeleton
                height={42}
                style={{ marginBottom: "5px", borderRadius: "15px" }}
                variant="rectangular"
              />
            </Box>
          </Box>
        </Box>
        <Skeleton
          height={42}
          style={{ marginBottom: "5px", borderRadius: "15px" }}
          variant="rectangular"
        />
      </Box>
    </>
  );
};
